import React, { useEffect, useRef, useState } from "react";
import style from "../systemSetting/systemSetting.module.css";
import axios from "axios";
import { ErrorToast, SuccessToast } from "../../../components/toastMessage";
import { BASE_URL } from "../../../constants/Constants";
import BoxComponent from "../../../components/CommonComponents/BoxComponent/BoxComponent";
import { _axios } from "../../../utils/axios";


const SystemSettings = () => {

    const [isOverRide, setIsOverRide] = useState(false);

    const fetchData = () => {
        _axios.post(`${BASE_URL}/api/controller/toggle`)
            .then((response) => {
                if (response?.data?.success === 0) {
                    ErrorToast(response?.data?.message)
                    return
                }
                const data = response.data.data[0];
                setIsOverRide(data.override_control == 1 ? true : false);
                console.log(response);
            })
            .catch((error) => {
                if (error?.response?.data?.message) {
                    ErrorToast(error?.response?.data?.message)
                }
                console.log('error', error);
            });
    };

    useEffect(() => {
        // Fetch data from the backend when the component mounts
        fetchData();
    }, []);

    const updateData = async () => {
        try {
            const response = await _axios.patch(
                `${BASE_URL}/api/controller/`,
                {
                    id: "1",
                    override_control: isOverRide ? 0 : 1,
                }
            );
            if (response?.data?.success === 0) {
                ErrorToast(response?.data?.message)
                return
            }
            SuccessToast('Override Controller Updated')
            fetchData()
            // setTimeout(() => {
            //     window.location.reload();
            // }, 2000);

            console.log(response.data); // Log the response from the backend
        } catch (error) {
            console.error("Error updating data:", error);
        }
    };

    // useEffect(() => {
    //     // Fetch data from the backend when the component mounts
    //     updateData();
    // }, []);

    const handleToggleChange = () => {
        updateData(); // Call updateData when toggle state changes
    };
    console.log(isOverRide);
    return (
        <div className={style.body}>
            <BoxComponent>
                <div className={style.bodyContanier}>
                    <div className={style.overrideActive}>
                        <label className={style.overrideActive}>Override Control for Level 3 Reviewer</label>
                        <label className={style.toggleBtn}>
                            <input
                                type="checkbox"
                                className={style.inputCheckbox}
                                checked={isOverRide} // Set the checked attribute based on the state
                                onChange={handleToggleChange} // Toggle the state on checkbox change
                            />
                            <span className={style.slider}></span>
                        </label>
                    </div>

                    {/* <hr/> */}
                </div >
            </BoxComponent>
        </div >
    );

};

export default SystemSettings;
